import React, {Component} from 'react';
import './imageUploader.scss';
import Cropper from 'react-cropper';
import heic2any from 'heic2any';
import {
  Button,
  Card,
  CardContent,
  Grid,
  Input,
  Paper,
  Typography,
} from '@material-ui/core';
import {sendImageEurofours, resetSendImage} from './store/action';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {translate} from 'react-admin';

class EurofoursUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: null,
      cropResult: null,
      imageName: null,
    };
  }

  onChange = async e => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    this.props.resetSendImage();
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({src: reader.result});
    };
    const file = files[0];
    if (file) {
      this.setState({imageName: file.name});
      if (file.name.toLocaleLowerCase().includes('.heic')) {
        let blobURL = URL.createObjectURL(files[0]);
        let blobRes = await fetch(blobURL);
        let blob = await blobRes.blob();
        let conversionResult = await heic2any({
          blob: blob,
          toType: 'image/jpeg',
          quality: 1,
        });

        reader.readAsDataURL(conversionResult);
      } else {
        reader.readAsDataURL(file);
      }
    }
  };

  cropImage = () => {
    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return;
    }
    this.setState({
      cropResult: this.cropper.getCroppedCanvas().toDataURL(),
    });
    this.props.sendImageEurofours({
      image: this.cropper.getCroppedCanvas().toDataURL(),
      name: this.state.imageName,
    });
  };

  render() {
    const {isUpdated, translate} = this.props;
    return (
      <Card>
        <CardContent>
          <Typography gutterBottom variant="headline" component="h1">
            {translate('custom.components.image_uploader.label')}
          </Typography>
        </CardContent>
        <Grid container>
          <Grid item xs={12}>
            <div
              style={{
                width: 400 + 'px',
                maxWidth: 400 + 'px',
                height: 300 + 'px',
              }}>
              <Input type="file" onChange={this.onChange} />
              <Cropper
                style={{height: 300 + 'px', width: 100 + '%'}}
                aspectRatio={1}
                preview=".img-preview"
                guides={false}
                zoomable={false}
                src={this.state.src}
                ref={cropper => {
                  this.cropper = cropper;
                }}
                responsive={true}
              />
            </div>
            {this.state.src ? (
              <div style={{paddingTop: 50 + 'px'}}>
                {isUpdated === true && (
                  <Paper
                    elevation={1}
                    style={{
                      backgroundColor: '#8cc97d',
                      paddingTop: 1 + 'em',
                      paddingBottom: 1 + 'em',
                      textAlign: 'center',
                    }}>
                    <Typography variant="headline" component="h3">
                      {translate('custom.images.upload.success')}
                    </Typography>
                  </Paper>
                )}
                {isUpdated === 'sending' && (
                  <Paper
                    elevation={1}
                    style={{
                      backgroundColor: '#a5d5ff',
                      paddingTop: 1 + 'em',
                      paddingBottom: 1 + 'em',
                      textAlign: 'center',
                    }}>
                    <Typography variant="headline" component="h3">
                      {translate('custom.images.upload.sending')}
                    </Typography>
                  </Paper>
                )}
                {isUpdated === false && (
                  <Paper
                    elevation={1}
                    style={{
                      backgroundColor: '#f8d7da',
                      paddingTop: 1 + 'em',
                      paddingBottom: 1 + 'em',
                      textAlign: 'center',
                    }}>
                    <Typography variant="headline" component="h3">
                      {translate('custom.images.upload.failure')}
                    </Typography>
                  </Paper>
                )}
                <div className="box">
                  <h1>
                    {translate('custom.components.image_uploader.previewLabel')}
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.cropImage}
                      disabled={isUpdated === 'sending'}
                      style={{float: 'right'}}>
                      {translate(
                        'custom.components.image_uploader.buttonLabel',
                      )}
                    </Button>
                  </h1>
                  <div
                    className="img-preview"
                    style={{
                      width: 200,
                      float: 'left',
                      height: 200,
                      overflow: 'hidden',
                      border: 1 + 'px solid gray',
                      borderRadius: 100 + '%',
                    }}
                  />
                </div>
              </div>
            ) : null}
          </Grid>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = ({imageReducer}) => ({
  isUpdated: imageReducer.isUpdated,
});

export default compose(
  translate,
  connect(mapStateToProps, {sendImageEurofours, resetSendImage}),
)(EurofoursUploader);
